import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
// removed confirm dialog per request
import { ToastService, useDataTable } from '@iamsoftware/react-hooks';
import { AgreementService } from 'src/app/hop-dong/quan-ly-hop-dong/AgreementService';

export const ThungRac: React.FC = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const [headerResult, setHeaderResult] = useState<any>(null);

  useEffect(() => {
    setHeaderResult(
      <div className="flex align-items-center justify-content-between ">
        <span>Thùng rác</span>
      </div>
    );
  }, []);

  const handleRestore = async (rowData: any) => {
    try {
      const id = rowData.agreementId;
      const res = await AgreementService.restoreAgreement(id);
      if (res && res.success === 'Y') {
        ToastService.success('Đã khôi phục tài liệu');
        reloadLazyData();
      } else {
        ToastService.error(res?.error || 'Không thể khôi phục tài liệu');
      }
    } catch (e) {
      ToastService.error('Có lỗi khi khôi phục tài liệu');
    }
  };

  // Bỏ nút xóa vĩnh viễn theo yêu cầu; chỉ còn làm trống thùng rác tổng

  const handleEmptyTrash = () => {
    ToastService.error('Chức năng làm trống thùng rác đang được phát triển');
  };

  const { render, reloadLazyData } = useDataTable({
    tableHeader: headerResult,
    dataKey: 'agreementId',
    indexColumnWidth: 45,
    actionColumnWidth: 140,
    columns: [
      { field: 'agreementName', header: 'Hợp đồng', width: 220, matchMode: 'contains' },
      { field: 'agreementPseudoId', header: 'Mã hợp đồng', width: 140, matchMode: 'contains' },
      { field: 'agreementTypeName', header: 'Loại hợp đồng', width: 160, matchMode: 'contains' },
      { field: 'statusDescription', header: 'Trạng thái', width: 120, dataType: 'custom', customCell() {
          return <Tag value="Đã xóa" severity="danger" />;
        }
      },
      { field: 'mainContent', header: 'File chính', width: 220, dataType: 'custom', customCell(row) {
          if (!row.mainContent) return <span className="text-gray-500">Chưa có file</span>;
          return (
            <div className="flex align-items-center gap-2">
              <i className={`pi ${row.mainContent.contentType === 'application/pdf' ? 'pi-file-pdf' : 'pi-file-word'} text-xl`}></i>
              <div>
                <div className="font-medium">{row.mainContent.fileName}</div>
                <small className="text-gray-500">{row.mainContent.contentType?.split('/')?.[1]?.toUpperCase()}</small>
              </div>
            </div>
          );
        }
      },
      { field: 'contentCount', header: 'Số file', width: 110, dataType: 'custom', customCell(row) {
          return <Tag value={`${row.contentCount || 0} file`} severity="info" />;
        }
      },
      { field: 'lastUpdatedStamp', header: 'Thời gian xóa', width: 160, dataType: 'date' }
    ],
    getList: (lazyLoadEvent) => {
      let eventData = lazyLoadEvent;
      if (typeof lazyLoadEvent === 'string') {
        try {
          eventData = JSON.parse(lazyLoadEvent);
        } catch (e) {
          eventData = { first: 0, rows: 20, filters: {} };
        }
      }
      if (!eventData.filters) eventData.filters = {};
      eventData.filters.statusId = { value: 'AGT_DELETED' };

      return AgreementService.getAgreementList(lazyLoadEvent, 'AGT_DELETED').then(result => {
        if (result.listData && Array.isArray(result.listData)) {
          result.listData = result.listData.map((item: any) => ({
            ...item,
            mainContent: item.mainFileName || item.mainContentType ? {
              fileName: item.mainFileName,
              contentType: item.mainContentType,
              contentLocation: item.mainContentLocation
            } : null
          }));
        }
        return {
          listData: result.listData || [],
          totalCount: result.totalRecords || (result.listData || []).length
        };
      });
    },
    initActions(items: Array<any>) {
      items?.forEach(item => {
        item.actions = [
          { icon: 'pi pi-refresh', title: 'Khôi phục', className: 'p-button-success', command: () => handleRestore(item) }
        ];
      });
    }
  });

  return (
    <div className="grid">
      <div className="col-12">
        <h3 className="m-0 mb-2">Thùng rác</h3>
      </div>
      <div className="col-12 pb-0" style={{maxHeight: 'calc(100vh - 12rem)'}}>
        <Toast ref={toast} />
        {render()}
      </div>
    </div>
  );
};

